export type FaqItem = {
  question: string;
  answer: string[];
};

export const FAQ_ITEMS: FaqItem[] = [
  {
    question: '마트통포스는 어떤 매장에 적합한가요?',
    answer: [
      '동네 슈퍼, 중소형 마트, 편의점형 매장, 도소매 유통, 프랜차이즈, 식당·외식업체 등 소상공인 매장에 맞춰 설계되었습니다. 신선식품과 공산품이 섞인 매장에서도 재고·가격·프로모션을 한곳에서 관리할 수 있습니다.',
      '업종별로 필요한 기능(저울 연동, 키오스크, 무인매장, CRM 등)이 다르므로, 상담 시 매장 형태를 알려주시면 우선 적용 범위를 제안합니다.',
    ],
  },
  {
    question: '기존에 쓰던 POS에서 상품·회원 데이터를 옮길 수 있나요?',
    answer: [
      '대부분의 경우 상품 마스터, 단가, 회원·포인트 등 핵심 데이터를 이전할 수 있습니다. 다만 기존 시스템의 내보내기 형식과 데이터 품질(중복 바코드, 누락 원가 등)에 따라 정리 기간이 달라집니다.',
      '전환 전에는 반드시 백업을 받고, 피크가 아닌 요일에 파일럿 전환을 권장합니다.',
    ],
  },
  {
    question: 'AI 재고예측은 어떻게 동작하나요?',
    answer: [
      '과거 판매 이력과 다양한 요인을 분석해 수요를 추정하고, 과다재고·품절을 줄이기 위한 발주 참고값을 제공합니다. 사람이 매일 감으로 하던 발주를 데이터 기반으로 보조하는 역할입니다.',
      '처음부터 전 품목을 자동화하기보다 매출·폐기 영향이 큰 상품군부터 적용하는 것이 효과적입니다.',
    ],
  },
  {
    question: 'ESL(전자가격표)과 POP는 꼭 함께 써야 하나요?',
    answer: [
      '필수는 아닙니다. 가격 변경이 잦은 카테고리부터 ESL을 도입하고, 시즌·행사 안내는 POP로 보완하는 조합이 일반적입니다. 종이 가격표만 사용할 때도 POP 제작 프로그램만 먼저 도입할 수 있습니다.',
      'POS와 가격 정보가 연동되어야 매대 표시 오류를 줄일 수 있습니다.',
    ],
  },
  {
    question: '키오스크만 따로 도입할 수 있나요?',
    answer: [
      '가능합니다. 다만 재고·가격·프로모션이 POS와 같아야 키오스크에서도 가격 분쟁이 발생하지 않습니다. 가능하면 동일 플랫폼으로 연동하는 구성을 권장합니다.',
      '완전 무인 전환 전, 피크 타임용 키오스크 1대로 시작하는 단계적 도입도 많이 선택합니다.',
    ],
  },
  {
    question: '무인매장 원격관리는 무엇을 할 수 있나요?',
    answer: [
      '스마트폰으로 매장 장비·운영 상태를 모니터링하고, 이상 징후를 빠르게 파악해 대응할 수 있도록 돕습니다. 상시 상주 인력을 줄이면서도 안정성을 유지하는 것이 목표입니다.',
      'CCTV·출입 통제·고가 상품 배치 등 현장 보안 설계와 함께 도입해야 효과가 큽니다.',
    ],
  },
  {
    question: '프로그램 비용은 어떻게 되나요?',
    answer: [
      '매장 규모, 선택 모듈(POS, 키오스크, ESL, CRM 등), 하드웨어 구성에 따라 달라집니다. O2O 플랫폼 지원 사업 등과 연계해 프로그램 제공이 가능한 경우도 있으니, 현재 모집·지원 여부를 상담 시 확인해 주세요.',
      '정확한 견적은 현장 환경 확인 후 안내드립니다. 고객문의 또는 02-6952-7652로 연락해 주세요.',
    ],
  },
  {
    question: '설치와 직원 교육은 얼마나 걸리나요?',
    answer: [
      '매장 규모와 데이터 이전 범위에 따라 다르지만, 일반적으로 환경 점검 → 데이터 정리 → 설치 → 교육 → 안정화 모니터링 순으로 진행합니다. 직원 교육은 계산·반품·재고·프로모션 등 실무 시나리오 중심으로 진행합니다.',
      '전국 총판·대리점 네트워크를 통해 지역별 설치·지원이 가능합니다.',
    ],
  },
  {
    question: 'CRM 모바일전단지로 주문까지 받을 수 있나요?',
    answer: [
      '네. AI로 제작한 모바일전단지를 회원에게 발송하고, 반응·주문 흐름을 관리할 수 있습니다. 상품 촬영 부담을 줄이면서도 주간 특가·마감 할인 같은 프로모션을 빠르게 전달하는 데 적합합니다.',
      '발송 시 개인정보 동의와 수신 거부 처리 등 관련 규정을 준수해야 합니다.',
    ],
  },
  {
    question: '고장이나 장애가 나면 어떻게 지원받나요?',
    answer: [
      '전화 및 원격 지원을 통해 우선 점검하고, 필요 시 지역 총판·대리점을 통해 현장 대응합니다. 장애 유형(결제, 프린터, 네트워크, 소프트웨어)에 따라 처리 절차가 달라질 수 있습니다.',
      '성수기 전 백업·주변기기 상태 점검, 용지·토너 여유분 확보를 권장합니다.',
    ],
  },
  {
    question: '개인정보는 어떻게 보호되나요?',
    answer: [
      '마트통포스는 개인정보처리방침에 따라 고객·회원 정보를 처리합니다. 자세한 수집 항목, 이용 목적, 보관 기간은 사이트 내 개인정보처리방침 페이지에서 확인할 수 있습니다.',
      '문의: kps@runninglab.co.kr / 02-6952-7652',
    ],
  },
  {
    question: '상담은 어떻게 신청하나요?',
    answer: [
      '사이트 고객문의 페이지에서 문의하시거나, 대표전화 02-6952-7652, 이메일 kps@runninglab.co.kr로 연락해 주세요. 매장 주소·업종·일 방문객·현재 사용 중인 POS를 알려주시면 더 정확한 안내가 가능합니다.',
      '본사는 경기 부천시 원미구 조마루로385번길 80 춘의테크노파크3차 1006호에 있습니다. 오시는 길 페이지의 지도를 참고해 주세요.',
    ],
  },
];
